const createBreadcrumb = () => [
  { name: "Dashboard", link: "/" },
  { name: "File Library", active: false },
];

export { createBreadcrumb };
